// src/components/GlobalFunction/installGlobalImageLazyLoad.js

let installed = false;

function patchImg(img) {
  if (!img || img.tagName !== "IMG") return;

  // Do not override images that already define loading manually.
  if (img.hasAttribute("loading")) {
    if (!img.hasAttribute("decoding")) {
      img.setAttribute("decoding", "async");
    }
    return;
  }

  // Only lazy-load images that explicitly opt in.
  // This prevents visible category images from staying blank until hover/repaint.
  if (img.dataset?.lazy === "1") {
    img.setAttribute("loading", "lazy");
    img.setAttribute("fetchpriority", "low");

    if (!img.hasAttribute("decoding")) {
      img.setAttribute("decoding", "async");
    }

    return;
  }

  // Default behavior: keep browser normal/eager behavior for visible images.
  // Still add async decoding because it is safe and does not delay visibility.
  img.setAttribute("decoding", "async");
}

export function installGlobalImageLazyLoad() {
  if (installed) return;
  installed = true;

  document.querySelectorAll("img").forEach(patchImg);

  const mo = new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      m.addedNodes.forEach((node) => {
        if (node?.tagName === "IMG") patchImg(node);
        node?.querySelectorAll?.("img").forEach(patchImg);
      });
    });
  });

  mo.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
}